import { Link } from "react-router-dom";
import { LucideIcon, ArrowRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface RelatedFeature {
  title: string;
  description: string;
  icon: LucideIcon;
  link: string;
}

interface RelatedFeaturesSectionProps {
  features: RelatedFeature[];
}

export function RelatedFeaturesSection({ features }: RelatedFeaturesSectionProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {features.map((feature) => {
        const Icon = feature.icon;
        return (
          <Link key={feature.link} to={feature.link}>
            <Card className="h-full transition-all duration-300 hover:shadow-lg hover:border-primary group cursor-pointer">
              <CardHeader>
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center mb-3 group-hover:bg-primary/20 transition-colors">
                  <Icon className="h-5 w-5 text-primary" />
                </div>
                <CardTitle className="text-lg flex items-center justify-between">
                  {feature.title}
                  <ArrowRight className="h-4 w-4 text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all" />
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">
                  {feature.description}
                </p>
              </CardContent>
            </Card>
          </Link>
        );
      })}
    </div>
  );
}
